import React, { useState } from 'react';
import styled from 'styled-components';
import { ContributionDetailsProps } from './ContributionDetails';
import TrueImpactText from 'shared/design-system/base/TrueImpactText';
import { numberWithCommas } from 'shared/utils/numberUtils';
import TrueImpactDollarField, {
  dollarToInt,
} from 'shared/design-system/components/TrueImpactDollarField';
import { SPACERS } from 'shared/design-system/settings/variables/Spacers';

type ContributionAmountsProps = ContributionDetailsProps

const StyledDiv = styled.div`
  display: flex;
  .left-amount-grid {
    flex: 1;
    display: grid;
    gap: ${SPACERS.large};
    grid-template-columns: repeat(2, minmax(200px, 1fr));
  }
  .right-amount-grid {
    flex: 1;
  }
  .donations-field {
    svg.icon {
      top: 14px;
    }
    input {
      padding-top: ${SPACERS.tiny};
      padding-bottom: ${SPACERS.tiny};
    }
  }
`;

interface DollarAmountProps {
  label: string;
  value: string;
  className?: string;
  setValue: React.Dispatch<React.SetStateAction<string>>;
}

const DollarAmount: React.FC<DollarAmountProps> = ({
  label,
  value,
  setValue,
  className,
}) => {
  return (
    <div>
      <TrueImpactText variant="body-small-bold" className="dollar-amount-label">
        {label}
      </TrueImpactText>
      <TrueImpactDollarField
        value={value}
        placeholder={label}
        disabled={false}
        onBlur={() =>
          setValue(
            value ? numberWithCommas(dollarToInt(value).toFixed(2)) : '0',
          )
        }
        onChange={setValue}
        className={className}
      />
    </div>
  );
};

const ContributionAmounts: React.FC<ContributionAmountsProps> = ({
  investment,
  className,
}) => {
  const [cash, setCash] = useState<string>(
    investment.cashAmount ? investment.cashAmount.toString() : '0',
  );
  const [goods, setGoods] = useState<string>(
    investment.goodsAmount ? investment.goodsAmount.toString() : '0',
  );
  const [volunteerism, setVolunteerism] = useState<string>(
    investment.volunteerismAmount
      ? investment.volunteerismAmount.toString()
      : '0',
  );
  const [services, setServices] = useState<string>(
    investment.servicesAmount ? investment.servicesAmount.toString() : '0',
  );
  return (
    <StyledDiv className={className}>
      <div className="left-amount-grid">
        <DollarAmount
          label="Cash amount"
          value={cash}
          setValue={setCash}
          className="donations-field"
        />
        <DollarAmount
          label="Goods value"
          value={goods}
          setValue={setGoods}
          className="donations-field"
        />
        <DollarAmount
          label="Volunteerism amount"
          value={volunteerism}
          setValue={setVolunteerism}
          className="donations-field"
        />
        <DollarAmount
          label="Services value"
          value={services}
          setValue={setServices}
          className="donations-field"
        />
      </div>
      <div className="right-amount-grid"></div>
    </StyledDiv>
  );
};

export default ContributionAmounts;
